import { render } from "./DataInputs.vue?vue&type=template&id=6bcbf1ab"
import script from "./DataInputs.vue?vue&type=script&lang=js"
export * from "./DataInputs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__